module.exports = __webpack_public_path__ + "img/LeatherArmor.50e9fcf2.gif";